import { SyncJobService } from './../../business-services/sync-job.service';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { SyncJobViewModel, TriggerJobRequestModel } from '../../business-entities/syncJob-view-model';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sync-jobs',
  templateUrl: './sync-jobs.component.html'
})
export class SyncJobsComponent implements OnInit {

  total$: Observable<number>;
  paginationSub: Subscription;
  syncJobList: SyncJobViewModel[];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private SyncJobService:SyncJobService,
    private translate: TranslateService,
    private toaster: ToastrService,
    ) { 
      this.pService.pageSize = 10;
      this.pService.searchby = [
        'jobName','description'
      ];
      this.pService.searchTerm = '';
    }

    onSort({ column, direction }: SortEvent) {
      this.headers.forEach(header => {
          if (header.sortable !== column) {
              header.direction = '';
          }
      });
    
      this.pService.sortColumn = column;
      this.pService.sortDirection = direction;
    }

  ngOnInit(): void {
    this.pService.dataSource = [];
    this.getSyncJobList();
  }

  getSyncJobList() {
    this.spinner.show();
    this.SyncJobService.getSyncJobList().then(response => {
      if (response && response.length>0) {
        this.pService.dataSource = response;
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.syncJobList = this.SyncJobDataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      } 
      else if ( response && response.errorCount > 0) 
      {
        if ( response.result && response.result.errorCode === Enums.ErrorCodes.ErrorCode) 
        {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  private SyncJobDataMapper(list: any) {
    let supperArray = [];
    if (list && list.length > 0) {
      for (let index = 0; index < list.length; index++) {
        const element = list[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.syncJobId = element.syncJobId;
        single.jobName = element.jobName;
        single.description = element.description;
        single.lastSyncTime = new Date(element.lastSyncTime + 'Z');
        single.isLastSyncSuccess = element.isLastSyncSuccess;
        single.isInProgress = element.isInProgress;
        single.lastSuccess = new Date(element.lastSuccess + 'Z');
        single.controllerName=element.controllerName;
        single.actionName=element.actionName;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  OnTriggerJob(syncJob:SyncJobViewModel)
  {
    this.spinner.show();
      let model:TriggerJobRequestModel={
        controllerName:syncJob.controllerName,
        actionName:syncJob.actionName,
        syncJobId:syncJob.syncJobId
      }
      this.SyncJobService.triggerJob(model).then(response => {
        if( response?.responseObject && response.responseObject===true)
        {
          this.spinner.hide();
          let successMessage = this.translate.instant('lblTriggerJobSuccessMessage');
          this.toaster.success(successMessage);
          this.getSyncJobList();
        }
        else if(response?.responseObject && response.responseObject===false)
        {
          this.spinner.hide();
          let errorMessage = this.translate.instant('lblTriggerJobErrorMessage');
          this.toaster.error(errorMessage);
        }
        else{
          this.spinner.hide();
        }
        this.spinner.hide();
      });
  }

    /**
    * Methid to generate auto row number based on per page size
    * @param cIndex
    */
     private currentPageNumber(cIndex: number): number {
      let rtPageNumber = 0;
      if (this.pService.page === 1) {
        rtPageNumber = cIndex + 1;
      } else if (this.pService.page > 1) {
        rtPageNumber =
          Number.parseInt(
            `${this.pService.pageSize * (this.pService.page - 1)}`
          ) +
          (cIndex + 1);
      }
  
      return rtPageNumber;
    }

    ngOnDestroy(): void {
      if (this.paginationSub) {
        this.paginationSub.unsubscribe();
      }
      this.pService.dealers$ = new BehaviorSubject<any[]>([]);
      this.pService.total$ = new BehaviorSubject<number>(0);
    }
}
